import authReducer from './Reducers/authReducer'
import categoryReducer from './Reducers/categoryReducer'
import productReducer from './Reducers/productReducer'
import sellerReducer from './Reducers/sellerReducer'
import OrderReducer from './Reducers/OrderReducer'
import PaymentReducer from './Reducers/PaymentReducer'
import dashboardIndexReducer from './Reducers/dashboardIndexReducer'
import bannerReducer from './Reducers/bannerReducer'
import contentReducer from "./Reducers/linksReducer";
import customerReducer from './Reducers/customerReducer'
import commissionReducer from './Reducers/commissionReducer'
import employeeReducer from './Reducers/employeeReducer'
import reviewReducer from './Reducers/reviewReducer'
import contactReducer from './Reducers/contactReducer'
import filterReducer from './Reducers/filterReducer'
import autoImportReducer from './Reducers/autoImportReducer'

const rootReducer = {
  auth: authReducer,
  category: categoryReducer,
  product: productReducer,
  seller: sellerReducer,
  order: OrderReducer,
  payment: PaymentReducer,
  dashboardIndex: dashboardIndexReducer,
  banner: bannerReducer,
  content: contentReducer,
  customer: customerReducer,
  commission: commissionReducer,
  employee: employeeReducer,
  review: reviewReducer,
  contact: contactReducer,
  filter: filterReducer,
  autoImport: autoImportReducer,
};
export default rootReducer